<template>
    <div class="shop-categories">
        <div class="slider">
            <div class="item">
                <div class="container">
                    <div class="col-12 float-left"
                         style="margin-top:150px;margin-bottom:30px;">
                        <h1>{{ shopCategory[0].shopCategoryName }}</h1>
                    </div>
                    <div class="col-12 col-md-8 offset-md-2 float-left">
                        <input type="text"
                               class="form-control rounded-pill"
                               placeholder="فروشگاه مورد نظر خود را جستجو کنید..." />
                    </div>
                </div>
            </div>
        </div>
        <div class="container p-0">
            <div class="category">
                <div class="content">
                    <div class="col-6 pr-2 pl-2 mb-4 col-lg-3 float-right z-10" v-for="(shop,index)  in shopCategory" :key="shop.shopId">
                        <router-link class="item" :to="{name: 'shop',params: {id: shop.shopId,name: shop.name.replace(/ /gi, '-')}}">
                            <div class="details">
                                <label>{{ shop.name }}</label>
                                <small v-if="shop.shopWagePercent" title="کارمزد ماهیانه" class="float-left">{{ shop.shopWagePercent }}%</small>
                            </div>
                            <div class="inner">
                                <div class="img" v-if="shop.imagePath"
                                     v-bind:style="{'background-image':'url(' + rootImagePath + shop.imagePath + ')'}"></div>
                                <div class="img" v-else
                                     v-bind:style="{'background-image':'url('+ require('../../assets/image/NoImage.jpg') +')'}"></div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            rootImagePath: {
                type: String
            },

            provinceName: {
                type: String
            },

            shopCategory: {
                type: Array
            }
        },

        data()
        {
            return {
                loading: true,
            };
        }
    };
</script>
<style scoped>
    .shop-categories {
        width: 100%;
        float: right;
        text-align: center;
        position: relative;
        background: #EAEDED;
    }

        .shop-categories .category {
            width: 100%;
            margin-top: 30px;
            float: left;
        }


        .shop-categories .content {
            width: 100%;
            float: right;
            padding-top: 30px;
        }

            .shop-categories .content .item {
                transition: all 0.5s;
                width: 100%;
                height: 370px;
                display: inline-block;
                padding: 10px;
                background: #fff;
            }

                .shop-categories .content .item .inner {
                    width: 100%;
                    height: 300px;
                    float: right;
                    position: relative;
                }

                .shop-categories .content .item .img {
                    background-position: center center;
                    background-size: cover;
                    background-repeat: no-repeat;
                    width: 100%;
                    height: 300px;
                }

                .shop-categories .content .item .details {
                    width: 100%;
                    color: #000;
                    text-align: right;
                    font-weight: bold;
                    font-size: 16px;
                }


    @media (max-width: 1024px) {
            .shop-categories .gradient {
                height: 230px;
            }

            .shop-categories .content .item {
                height: 230px;
                padding: 5px;
            }

                .shop-categories .content .item .inner,
                .shop-categories .content .item .img {
                    height: 190px;
                }

                .shop-categories .content .item .details {
                    font-size: 14px;
                }
    }

    .slider,
    .slider .item {
        width: 100%;
        float: left;
        height: 300px;
    }

    .slider {
        padding: 0 !important;
        margin-bottom: 0;
    }

        .slider .item {
            background: #292929;
        }

        .slider h1 {
            position: relative;
            text-align: center;
            color: #fff;
            font-size: 25px;
        }

    .section-title {
        width: 100%;
        text-align: center;
    }

        .section-title h2 {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 10px;
            padding-bottom: 20px;
            position: relative;
        }

            .section-title h2::before {
                content: "";
                position: absolute;
                display: block;
                width: 120px;
                height: 1px;
                background: #ddd;
                bottom: 1px;
                left: calc(50% - 60px);
            }

            .section-title h2::after {
                content: "";
                position: absolute;
                display: block;
                width: 40px;
                height: 3px;
                background: #d00918;
                bottom: 0;
                left: calc(50% - 20px);
            }

        .section-title p {
            margin-bottom: 0;
        }

        .section-title.light {
            color: #ddd;
        }
</style>
